import { View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { useIsBenefitScreenPresentedAsModal } from '@/src/experiences/card-benefits/components/BenefitModal'
import { mesaColorNames } from '@/src/common/theme'

export const CardBenefitsComponentsContainer = ({ children }: { children: React.ReactNode }) => {
  const isBenefitScreenPresentedAsModal = useIsBenefitScreenPresentedAsModal()
  return (
    <SafeAreaView
      edges={['top']}
      style={[
        {
          flex: 1,
          backgroundColor: mesaColorNames['Mesa - Brand/Secondary #223843'],
        },
        !isBenefitScreenPresentedAsModal && {
          paddingHorizontal: 14,
          paddingTop: 16,
        },
      ]}
    >
      <View testID="CardBenefits.View.BenefitDetails" style={{ flex: 1 }}>
        {children}
      </View>
    </SafeAreaView>
  )
}
